import { render, staticRenderFns } from "./ColumnsSelect.vue?vue&type=template&id=4c6a6477&"
import script from "./ColumnsSelect.vue?vue&type=script&lang=ts&"
export * from "./ColumnsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection,QCheckbox,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection,QCheckbox,QIcon})
